export default __webpack_public_path__ + "static/media/ic_ossetia.5d8df2a3.svg";